export default {"src":"/_next/static/media/gstreet-logo.fed95c39.svg","height":79,"width":300,"blurWidth":0,"blurHeight":0};